import { useEffect, useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Ribbon from "@/components/site/Ribbon";
import Fleet from "@/components/site/Fleet";
import Manifesto from "@/components/site/Manifesto";
import ServiceAreas from "@/components/site/ServiceAreas";
import BookingSection from "@/components/site/BookingSection";
import Footer from "@/components/site/Footer";
import { getSettings } from "@/lib/api";

const FALLBACK = { phone: "516 262 2059", email: "Aydinsarikaya1720@gmail.com", clover_payment_link: "", vehicles: [] };

export default function Landing() {
  const [settings, setSettings] = useState(FALLBACK);
  useEffect(() => { getSettings().then((s) => setSettings({ ...FALLBACK, ...s })).catch(() => {}); }, []);
  return (
    <div className="bg-ink min-h-screen" data-testid="landing-page">
      <Header phone={settings.phone} payLink={settings.clover_payment_link} />
      <Hero phone={settings.phone} />
      <Ribbon />
      <Fleet />
      <Manifesto />
      <ServiceAreas />
      <BookingSection settings={settings} />
      <Footer phone={settings.phone} email={settings.email} payLink={settings.clover_payment_link} />
    </div>
  );
}
